function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}
if (!customElements.get('details-disclosure')) {
  class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details') || null;
      this.content = this.mainDetailsToggle && this.mainDetailsToggle.querySelector('summary') && this.mainDetailsToggle.querySelector('summary').nextElementSibling || null;
      if (!this.mainDetailsToggle || !this.content) return;
      this.onFocusOut = this.onFocusOut.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut);
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle);
    }
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }
    onToggle() {
      if (!this.content || !this.content.getAnimations) return;
      if (!this.animations) this.animations = this.content.getAnimations() || [];
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.animations.forEach(a => a && a.play && a.play());
      } else {
        this.animations.forEach(a => a && a.cancel && a.cancel());
      }
    }
    close() {
      if (!this.mainDetailsToggle) return;
      this.mainDetailsToggle.removeAttribute('open');
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
  }
  customElements.define('details-disclosure', DetailsDisclosure);
}
if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends customElements.get('details-disclosure') {
    constructor() {
      super();
      this.mainDetailsToggle = this.mainDetailsToggle || this.querySelector('details') || null;
      this.elements = {
        shareButton: this.querySelector('.share-button__button.hidden') || null,
        shareSummary: this.querySelector('summary.share-button__button') || this.querySelector('summary') || null,
        closeButton: this.querySelector('.share-button__close') || null,
        successMessage: this.querySelector('[id^="ShareMessage"]') || null,
        urlInput: this.querySelector('input') || null,
        copyButton: this.querySelector('.share-button__copy') || null
      };
      if (!this.mainDetailsToggle || !this.elements.shareSummary) return;
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
      if (this.elements.urlInput && typeof this.elements.urlInput.value === 'string') {
        try {
          this.elements.urlInput.size = Math.max(10, this.elements.urlInput.value.length - 3);
        } catch (e) {}
      }
      if (typeof navigator !== 'undefined' && !!navigator.share) {
        this.mainDetailsToggle.setAttribute('hidden', '');
        if (this.elements.shareButton) {
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({
              url: this.urlToShare,
              title: document.title
            }).catch(() => {});
          });
        }
      } else {
        this.toggleDetails = this.toggleDetails.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.close = this.close.bind(this);
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails);
        if (this.elements.copyButton) {
          this.elements.copyButton.addEventListener('click', this.copyToClipboard);
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.close);
        }
      }
    }
    toggleDetails() {
      if (!this.mainDetailsToggle || this.mainDetailsToggle.open) return;
      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
      }
      if (this.elements.closeButton) this.elements.closeButton.classList.add('hidden');
      if (this.elements.shareSummary) this.elements.shareSummary.focus();
    }
    copyToClipboard() {
      if (!this.elements.urlInput) return;
      const text = this.elements.urlInput.value;
      const write = () => navigator.clipboard.writeText(text).catch(() => {
        const tmp = document.createElement('textarea');
        tmp.value = text;
        tmp.style.position = 'fixed';
        tmp.style.opacity = '0';
        document.body.appendChild(tmp);
        tmp.select();
        try {
          document.execCommand('copy');
        } catch (e) {}
        document.body.removeChild(tmp);
      });
      write().then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings && window.accessibilityStrings.shareSuccess || 'Link copied';
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        }
      });
    }
    updateUrl(url) {
      this.urlToShare = url;
      if (this.elements.urlInput) this.elements.urlInput.value = url;
    }
  });
}
